<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card
      class=""
      :bordered="false"
      :padding="0"
      >
      <p slot="title">
        工单详情
      </p>
      <div class="top" style="padding: 10px 16px">
        <Button
          type="ghost"
          icon="ios-undo"
          @click="back"
        >返回</Button>
      </div>
    </Card>
      <div class="content">
        <Card
          class="smy__card-full card-left"
          :bordered="false"
          >
          <OrderDetailLeft
          :orderDetail="orderDetail"
          :buyPeople="buyPeople"
          />
        </Card>
        <div
          class="smy__card-full card-right"
          >
          <Card
          :bordered="false"
          >
          <OrderDetailTop
            ref="orderDetailTop"
            :orderDetail="orderDetail"
          />
          </Card>
        <Card
        style="margin-top:10px"
        :bordered="false"
        >
        <OrderDetailRight
          ref="orderDetailRight"
          :orderDetail="orderDetail"
        />
        </Card>
      </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

import OrderDetailLeft from './OrderDetailLeft'
import OrderDetailRight from './OrderDetailRight'
import OrderDetailTop from './OrderDetailTop'

export default {
  components: {
    OrderDetailLeft,
    OrderDetailRight,
    OrderDetailTop
  },
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      orderDetail: {},
      buyPeople: []
    }
  },
  methods: {
    back () {
      this.$router.back()
    }
  },
  created () {
    this.$http.get('/dropdown/chargePackage').then(res => {
      this.buyPeople = res.data
    })
  },
  beforeRouteEnter (to, from, next) {
    axios.get(`/order/info/${to.params.orderId}`).then(res => {
      next(vm => {
        vm.orderDetail = res.data
      })
    })
  }
}
</script>

<style lang="less" scoped>
.content {
  margin-top: 10px;
  flex: 1;
  display: flex;

  .card-left {
    width: 300px;
    height: 100%;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/agOrderPay/orderDetail.vue